// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListNotFound-space1-h7yz8 {
	margin-bottom: 6px !important;
}

.ListNotFound-space2-E8ZYO {
	margin-bottom: 12px !important;
}

.ListNotFound-space3-dvB1P {
	margin-bottom: 18px !important;
}

.ListNotFound-space4-nwyr2 {
	margin-bottom: 24px !important;
}

.ListNotFound-space5-iFJju {
	margin-bottom: 30px !important;
}

.ListNotFound-space6-XOPmQ {
	margin-bottom: 36px !important;
}

.ListNotFound-space7-nkMaY {
	margin-bottom: 42px !important;
}

.ListNotFound-spaceTop8-J6B1B {
	margin-bottom: 48px !important;
}

.ListNotFound-spaceTop1-XTta2 {
	margin-top: 6px !important;
}

.ListNotFound-spaceTop2-WEc9E {
	margin-top: 12px !important;
}

.ListNotFound-spaceTop3-glbqS {
	margin-top: 18px !important;
}

.ListNotFound-spaceTop4-RHEKR {
	margin-top: 24px !important;
}

.ListNotFound-spaceTop5-dwwOg {
	margin-top: 30px !important;
}

.ListNotFound-spaceTop6-mhjlJ {
	margin-top: 36px !important;
}

.ListNotFound-spaceTop7-t8T72 {
	margin-top: 42px !important;
}

.ListNotFound-spaceTop8-J6B1B {
	margin-top: 48px !important;
}

.ListNotFound-noMargin-QGQTZ {
	margin: 0px !important;
}

.ListNotFound-padding1-LD4Hn {
	padding-bottom: 6px !important;
}

.ListNotFound-padding2-y9dgI {
	padding-bottom: 12px !important;
}

.ListNotFound-padding3-liDPY {
	padding-bottom: 18px !important;
}

.ListNotFound-padding4-UImjI {
	padding-bottom: 24px !important;
}

.ListNotFound-padding5-VhRSw {
	padding-bottom: 30px !important;
}

.ListNotFound-padding6-a9Cw_ {
	padding-bottom: 36px !important;
}

.ListNotFound-padding7-gnUiz {
	padding-bottom: 42px !important;
}

.ListNotFound-paddingTop1-Y0DPA {
	padding-top: 6px !important;
}

.ListNotFound-paddingTop2-VgJ6C {
	padding-top: 12px !important;
}

.ListNotFound-paddingTop3-ix4Q2 {
	padding-top: 18px !important;
}

.ListNotFound-paddingTop4-rSm8y {
	padding-top: 24px !important;
}

.ListNotFound-paddingTop5-Uiq9k {
	padding-top: 30px !important;
}

.ListNotFound-paddingTop6-WHoO2 {
	padding-top: 36px !important;
}

.ListNotFound-paddingTop7-hZqxf {
	padding-top: 42px !important;
}

.ListNotFound-noPadding-v5uFB {
	padding: 0px !important;
}

.ListNotFound-textBold-NbmPP {
	font-weight: 500 !important;
}

.ListNotFound-textBolder-RPHHk {
	font-weight: 700 !important;
}

.ListNotFound-textNormal-OgVJA {
	font-weight: normal !important;
}

.ListNotFound-spaceBottom20-JQafh {
	margin-bottom: 20px;
}

.ListNotFound-spaceBottom10-ywLOo {
	margin-bottom: 10px;
}

.ListNotFound-marginNone-YIndL {
	margin: 0;
}

.ListNotFound-spaceBottom15-fwfbW {
	margin-bottom: 15px;
}

.ListNotFound-marginTopNone-zSuFE {
	margin-top: 0;
}

.ListNotFound-spaceTop11-kKJv8 {
	margin-top: 11px;
}

.ListNotFound-spaceTop21-i0F6O {
	margin-top: 21px;
}

.ListNotFound-spaceTop20-jnmvE {
	margin-top: 20px;
}

.ListNotFound-spaceTop10-iwGwo {
	margin-top: 10px;
}

/*New Design Text Colors */

.ListNotFound-textDarkBlue-CPh4g {
	color: rgb(20, 39, 94) !important;
}

.ListNotFound-textLightBlue-qt0R0 {
	color: rgb(57, 87, 106) !important;
}

.ListNotFound-textLightSandleGreen-BOrvM {
	color: rgb(76, 86, 41) !important;
}

.ListNotFound-textLightBrown-yukxD {
	color: rgb(115, 79, 33) !important;
}

.ListNotFound-textMediumMaroon-YTxZ0 {
	color: rgb(87, 37, 51) !important;
}

.ListNotFound-textBrown-EbNfL {
	color: rgb(160, 47, 24) !important;
}

.ListNotFound-textMaroon-XU3ev {
	color: rgb(155, 49, 67) !important;
}

.ListNotFound-textDarkBrown-y9RCc {
	color: rgb(83, 18, 16) !important;
}

.ListNotFound-textMediumBrown-DSFLH {
	color: rgb(142, 28, 10) !important;
}

.ListNotFound-textSkyBlue-k2dvE {
	color: rgb(37, 117, 141) !important;
}

.ListNotFound-textGray-pPdSm {
	color: rgb(77, 65, 51) !important;
}

.ListNotFound-root-TCF4z {
	padding-left: 20px;
	padding-right: 20px;
}

.ListNotFound-container-eknam {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: var(--max-content-width);
}

.ListNotFound-textJumbo-s8dj8 {
	font-size: 145px;
	font-weight: bold;
	margin: 0;
}

.ListNotFound-textMedium-QApVv {
	font-size: 85px;
	font-weight: bold;
	margin: 0;
}

.ListNotFound-textCenter-Pk7yg {
	text-align: center;
}

.ListNotFound-listStyled-pe8tx {
	padding-left: 0;
	list-style: none;
}

.ListNotFound-subTitle-VAZ5C {
	font-size: 15px;
	color: var(--primary-foreground);
}

a,
a:hover {
	color: var(--primary-link-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/routes/listNotFound/ListNotFound.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;;CAEC,qCAAqC;AACtC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: var(--max-content-width);\n}\n\n.textJumbo {\n\tfont-size: 145px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 85px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.listStyled {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.subTitle {\n\tfont-size: 15px;\n\tcolor: var(--primary-foreground);\n}\n\na,\na:hover {\n\tcolor: var(--primary-link-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ListNotFound-space1-h7yz8`,
	"space2": `ListNotFound-space2-E8ZYO`,
	"space3": `ListNotFound-space3-dvB1P`,
	"space4": `ListNotFound-space4-nwyr2`,
	"space5": `ListNotFound-space5-iFJju`,
	"space6": `ListNotFound-space6-XOPmQ`,
	"space7": `ListNotFound-space7-nkMaY`,
	"spaceTop8": `ListNotFound-spaceTop8-J6B1B`,
	"spaceTop1": `ListNotFound-spaceTop1-XTta2`,
	"spaceTop2": `ListNotFound-spaceTop2-WEc9E`,
	"spaceTop3": `ListNotFound-spaceTop3-glbqS`,
	"spaceTop4": `ListNotFound-spaceTop4-RHEKR`,
	"spaceTop5": `ListNotFound-spaceTop5-dwwOg`,
	"spaceTop6": `ListNotFound-spaceTop6-mhjlJ`,
	"spaceTop7": `ListNotFound-spaceTop7-t8T72`,
	"noMargin": `ListNotFound-noMargin-QGQTZ`,
	"padding1": `ListNotFound-padding1-LD4Hn`,
	"padding2": `ListNotFound-padding2-y9dgI`,
	"padding3": `ListNotFound-padding3-liDPY`,
	"padding4": `ListNotFound-padding4-UImjI`,
	"padding5": `ListNotFound-padding5-VhRSw`,
	"padding6": `ListNotFound-padding6-a9Cw_`,
	"padding7": `ListNotFound-padding7-gnUiz`,
	"paddingTop1": `ListNotFound-paddingTop1-Y0DPA`,
	"paddingTop2": `ListNotFound-paddingTop2-VgJ6C`,
	"paddingTop3": `ListNotFound-paddingTop3-ix4Q2`,
	"paddingTop4": `ListNotFound-paddingTop4-rSm8y`,
	"paddingTop5": `ListNotFound-paddingTop5-Uiq9k`,
	"paddingTop6": `ListNotFound-paddingTop6-WHoO2`,
	"paddingTop7": `ListNotFound-paddingTop7-hZqxf`,
	"noPadding": `ListNotFound-noPadding-v5uFB`,
	"textBold": `ListNotFound-textBold-NbmPP`,
	"textBolder": `ListNotFound-textBolder-RPHHk`,
	"textNormal": `ListNotFound-textNormal-OgVJA`,
	"spaceBottom20": `ListNotFound-spaceBottom20-JQafh`,
	"spaceBottom10": `ListNotFound-spaceBottom10-ywLOo`,
	"marginNone": `ListNotFound-marginNone-YIndL`,
	"spaceBottom15": `ListNotFound-spaceBottom15-fwfbW`,
	"marginTopNone": `ListNotFound-marginTopNone-zSuFE`,
	"spaceTop11": `ListNotFound-spaceTop11-kKJv8`,
	"spaceTop21": `ListNotFound-spaceTop21-i0F6O`,
	"spaceTop20": `ListNotFound-spaceTop20-jnmvE`,
	"spaceTop10": `ListNotFound-spaceTop10-iwGwo`,
	"textDarkBlue": `ListNotFound-textDarkBlue-CPh4g`,
	"textLightBlue": `ListNotFound-textLightBlue-qt0R0`,
	"textLightSandleGreen": `ListNotFound-textLightSandleGreen-BOrvM`,
	"textLightBrown": `ListNotFound-textLightBrown-yukxD`,
	"textMediumMaroon": `ListNotFound-textMediumMaroon-YTxZ0`,
	"textBrown": `ListNotFound-textBrown-EbNfL`,
	"textMaroon": `ListNotFound-textMaroon-XU3ev`,
	"textDarkBrown": `ListNotFound-textDarkBrown-y9RCc`,
	"textMediumBrown": `ListNotFound-textMediumBrown-DSFLH`,
	"textSkyBlue": `ListNotFound-textSkyBlue-k2dvE`,
	"textGray": `ListNotFound-textGray-pPdSm`,
	"root": `ListNotFound-root-TCF4z`,
	"container": `ListNotFound-container-eknam`,
	"textJumbo": `ListNotFound-textJumbo-s8dj8`,
	"textMedium": `ListNotFound-textMedium-QApVv`,
	"textCenter": `ListNotFound-textCenter-Pk7yg`,
	"listStyled": `ListNotFound-listStyled-pe8tx`,
	"subTitle": `ListNotFound-subTitle-VAZ5C`
};
module.exports = ___CSS_LOADER_EXPORT___;
